{
  "version": 1,
  "asset_id": "54d614b9-55a1-45c2-a5eb-65aebb3b0dc4",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/54d614b9-55a1-45c2-a5eb-65aebb3b0dc4/ss01-card-n3.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/54d614b9-55a1-45c2-a5eb-65aebb3b0dc4/ss01-card-n3.webp",
  "original_filename": "ss01-card-n3.webp",
  "size": 110986,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:34Z"
}
